import React from 'react';
import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ROLE_COLORS, ROLE_LABELS } from '../../config/constants';

const UserRoleBadge = ({ role }) => {
  const color = ROLE_COLORS[role] || '#9DA9BB';
  const label = ROLE_LABELS[role] || role || 'Unknown';

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: alpha(color, 0.12),
        color: color,
        fontWeight: 600,
        fontSize: '0.75rem',
        borderRadius: 1.5,
        transition: 'all 0.2s ease',
        '& .MuiChip-label': {
          px: 1,
        },
      }}
    />
  );
};

export default UserRoleBadge;
